import { Field, Form, Formik, FormikHelpers } from 'formik'
import { FC, ReactElement, useState } from 'react'
import * as yup from 'yup'
import Button from '../../components/button'
import FileInput from '../../components/fileInput'
import H3 from '../../components/h3'
import Input from '../../components/input'
import Modal from '../../components/modal'
import { useContact } from '../../hooks/faq'
import { RoutesEnum } from '../../utils/routesEnum'
import Default from '../loggedArea/default'
import { Buttons } from '../profile/styles'
import { Container } from './style'

const schema = yup.object().shape({
  body: yup.string().required('Conteúdo obrigatório')
})

type ContactForm = {
  body: string
  files?: File[]
}

const Contact: FC = (): ReactElement => {
  const [isOpen, setOpen] = useState(false)
  const { createTicket } = useContact()

  const submit = async (values: ContactForm, helpers: FormikHelpers<ContactForm>): Promise<void> => {
    helpers.setSubmitting(true)
    try {
      await createTicket(values.body, values.files)
      helpers.resetForm()
      setOpen(true)
    } catch { }
    helpers.setSubmitting(false)
  }

  return (
    <div>
      <Default
        breadcrumbs={[
          { title: 'Ajuda e Suporte', to: RoutesEnum.CONTACT },
          { title: 'Ajuda', to: RoutesEnum.CONTACT }
        ]}
        title='Ajuda e suporte'
        subtitle='Tire suas duvidas aqui!'
      >
        <H3>Suporte especializado</H3>
        <Formik
          validationSchema={schema}
          initialValues={{ body: '' }}
          onSubmit={submit}
        >
          {({ isSubmitting, isValid }) => (
            <Form>
              <Container>
                <Field
                  component={Input}
                  name='body'
                  type='textarea'
                  placeholder='Digite sua dúvida que vamos retornar o mais breve possível!'
                />
                <Field
                  label='PDF do Exame'
                  name='files'
                  isMulti
                  component={FileInput}
                />
                <Buttons>
                  <Button
                    isLoading={isSubmitting}
                    block
                    disabled={!isValid}
                    type='submit'
                  >
                    ENVIAR PARA O SUPORTE
                  </Button>
                </Buttons>
                {isOpen && (
                  <Modal
                    title='Sucesso'
                    okButtonText='OK'
                    onOk={() => {
                      setOpen(false)
                    }}
                  >
                    Ticket criado com sucesso!
                  </Modal>
                )}
              </Container>
            </Form>
          )}
        </Formik>
      </Default>
    </div>
  )
}

export default Contact
